import {
  Box,
  Typography,
  Divider,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { JobWithBullStatus } from '@bandido/shared/interfaces';

import { JobStatusChip } from './JobStatusChip';
import { ParametersDisplay } from './ParametersDisplay';
import { ErrorDisplay } from './ErrorDisplay';
import {
  accordionStyles,
  accordionSummaryStyles,
  accordionSummaryContentStyles,
  accordionSummaryInfoStyles,
  accordionSummaryActionsStyles,
  accordionDetailsStyles,
} from './styles';

interface JobAccordionProps {
  job: JobWithBullStatus;
}

export const JobAccordion = ({ job }: JobAccordionProps) => {
  const { t } = useTranslation();

  return (
    <Accordion elevation={0} sx={accordionStyles}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={accordionSummaryStyles}
      >
        <Box sx={accordionSummaryContentStyles}>
          <Box sx={accordionSummaryInfoStyles}>
            <Box>
              <Typography variant="subtitle2" fontWeight={600} mb={0.5}>
                {job.action}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                ID: {job.id}
              </Typography>
            </Box>
          </Box>
          <Box sx={accordionSummaryActionsStyles}>
            <JobStatusChip status={job.status} />
          </Box>
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={accordionDetailsStyles}>
        <Typography variant="body2" fontWeight={500} mb={1}>
          {t('hotelContent.jobs.modal.parameters')}:
        </Typography>
        <ParametersDisplay params={job.parameters} />

        {job.errorMessage && (
          <Box mt={2}>
            <Typography variant="body2" fontWeight={500} mb={1}>
              {t('hotelContent.jobs.modal.errors')}:
            </Typography>
            <ErrorDisplay errors={job.errorMessage} />
          </Box>
        )}

        <Divider sx={{ my: 2 }} />

        <Stack spacing={0.5}>
          <Typography variant="caption" color="text.secondary">
            {t('hotelContent.jobs.modal.created')}: {new Date(job.createdAt).toLocaleString('es-ES')}
          </Typography>
          {job.startedAt && (
            <Typography variant="caption" color="text.secondary">
              {t('hotelContent.jobs.modal.started')}: {new Date(job.startedAt).toLocaleString('es-ES')}
            </Typography>
          )}
          {job.finishedAt && (
            <Typography variant="caption" color="text.secondary">
              {t('hotelContent.jobs.modal.finished')}: {new Date(job.finishedAt).toLocaleString('es-ES')}
            </Typography>
          )}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
